import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const CreateProgramFooterWrapper = styled.div`
  margin: 16px 0px;
  background-color: ${COLORS.cirrus_white};
  padding: 32px 16px 20px;
  display: flex;
  justify-content: space-between;

  ${responsive.MOBILE`
    flex-direction: column;
    align-items: stretch;
    padding: 16px 8px 20px;
    gap: 12px;

    .button-group {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    > div:first-child {
      order: 3;
      display: flex;
      justify-content: center;
    }

    .button-group > button:last-child {
      order: 1;
    }

    .button-group > button:first-child {
      order: 2;
    }
  `}

  .btn-secondary {
    margin-right: 16px;

    ${responsive.MOBILE`
      margin-right: 0px;
    `}
  }
`;
